var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shadow leftCardBottomBorder"},[_c('div',{staticClass:"w-100 bg-secondaryColor p-1 text-white leftCardTopBorder"},[_c('p',{staticClass:"mb-0 h4 font-weight-bold",staticStyle:{"color":"inherit"},domProps:{"textContent":_vm._s(_vm.title)}})]),_c('b-container',{staticClass:"p-1 bg-white rounded-bottom"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }